import React from 'react'
import { useHistory } from 'react-router-dom'
import getPmCheckQuery from '../../lib/api/pm/pmCheck'
import pmCheck from '../../lib/api/pm/pmCheck'
import NetworkError from '../../pages/NetworkError'
import ServerError from '../../pages/ServerError'
import Loading from '../Loading'

type ErrorFallbackProps = {
  error: Error
}

function ErrorFallback({ error }: ErrorFallbackProps) {
  const { data: pmData, isLoading, isError } = getPmCheckQuery()
  const history = useHistory()

  if (isLoading) {
    return <Loading />
  }

  // BAD_GATEWAY 인 경우
  if (error.message === 'BAD_GATEWAY') {
    const { title, content, msg1, msg2 } = pmData

    return (
      <div className="wrap">
        <div className="notice_wrap">
          <button className="btn-out" onClick={() => (window.location.href = '/mobileWjdict')}>
            화면 벗어나기
          </button>

          <h1 className="main_tit">
            {title.split('\\n').map((line: string) => (
              <>
                {line}
                <br />
              </>
            ))}
          </h1>
          <p className="detail_txt">
            {content.split('\\n').map((line: string) => (
              <>
                {line}
                <br />
              </>
            ))}
          </p>
          <dl className="lbl_list">
            <dt>작업일시</dt>
            <dd>
              {msg1.split('\\n').map((line: string) => (
                <>
                  {line}
                  <br />
                </>
              ))}
            </dd>
            <dt>작업소요시간</dt>
            <dd>{msg2}</dd>
          </dl>
        </div>
      </div>
    )
  }

  // 네트워크 에러인경우
  // if (error.message === 'NETWORK ERROR') {
  //   return <NetworkError isError />
  // }

  // 그 외 에러 -> 서버 에러로 판판해서 페이지 보여주기
  return <ServerError isError />
}

export default ErrorFallback
